module.exports = __webpack_public_path__ + "img/client4.961bd821.png";